var MpPageConditions;

(function() {
    if (!document.querySelector('#vue-conditions')) {
        return;
    }

    MpPageConditions = new Vue({
        el: '#vue-conditions',
        data: {
            accept: false,
            conditionsRead: false,

            errors: [],
            successMessage: '',

            isValidated: false,
            isLegalShown: false,
            isInitialized: false,
        },
        computed: {},
        methods:{

            closeLegalModal: function() {
                noScroll.off();
                this.isLegalShown = false;
            },

            showLegalConditions: function(ev) {
                if (ev.target.tagName === 'A') {
                    ev.preventDefault();
                    noScroll.on();
                    this.conditionsRead = true;
                    this.isLegalShown = true;
                }
            },

            checkConditionsRead: function(ev) {
                this.isValidated = true;

                if (!this.conditionsRead) {
                    this.accept = false;
                }
            },

            acceptConditions: function() {

            },

            init: function() {
                if (this.isInitialized) {
                    return;
                }

                this.isInitialized = true;
            },
        },
        filters: {},
        mounted: function() {
            this.init();
        }
    });

})();
